import { api } from './client'

export type IntegrationId = 'whatsapi' | 'zabbix' | 'ldap' | 'jira'
export type IntegrationScope = 'global' | 'per_tenant'

export interface IntegrationSecret {
  integration: IntegrationId
  scope: IntegrationScope
  configured: boolean
  secret_arn?: string
  console_url?: string
  error_message?: string
  tenants_count?: number
  per_tenant_url?: string
}

export interface IntegrationStatus {
  integrations: IntegrationSecret[]
}

export interface HealthResult {
  status: 'ok' | 'degraded' | 'error'
  latency_ms: number | null
  message: string
  checked_at: string
}

export const integrationsApi = {
  getStatus: () =>
    api.get<IntegrationStatus>('/v1/admin/integrations/status').then(r => r.data),

  checkHealth: (id: IntegrationId) =>
    api.post<HealthResult>(`/v1/admin/integrations/${id}/health-check`).then(r => r.data),
}
